import React from "react"
import { useForm } from "react-hook-form"
import { ErrorMessage } from "@hookform/error-message"
import emailjs from '@emailjs/browser';


import { Wrapper, Content, Form, Divider, Social } from "./Contact.styles"
import Button from "../button/Button"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

// icons
import {
  faFacebookF,
  faTwitter,
  faInstagram,
  faGithub,
  faLinkedinIn,
} from "@fortawesome/free-brands-svg-icons"

import { faEnvelopeOpen } from "@fortawesome/free-solid-svg-icons"

const ContactForm = () => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    criteriaMode: "all",
  })

  const onSubmit = data => {
    console.log(data)
    emailjs.send("service_fq8fz69", "template_fkp206w", data, "Md92Rzf6KFu0sC_2Q")
            .then((result) => {
                console.log(result);
            }, (error) => {
                console.log(error);
            });
  }
  return (
    <Wrapper>
      <Content>
        <h1>Contact Me</h1>
        <p>For work and collaboration</p>
        <Form onSubmit={handleSubmit(onSubmit)}>
          <label htmlFor="email">Email</label>
          <input
            {...register("email", {
              required: "This field is required",
              pattern: {
                value: /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/,
                message: "This is not a valid email adress",
              },
            })}
          />
          <ErrorMessage
            errors={errors}
            name="email"
            render={({ messages }) =>
              messages &&
              Object.entries(messages).map(([type, message]) => (
                <p key={type}>{message}</p>
              ))
            }
          />
          <label htmlFor="subject">Subject</label>
          <input
            {...register("subject", {
              required: "This field is required",
              maxLength: {
                value: 100,
                message: "This field must not exceed 100 characters long",
              },
            })}
          />
          <ErrorMessage
            errors={errors}
            name="subject"
            render={({ messages }) =>
              messages &&
              Object.entries(messages).map(([type, message]) => (
                <p key={type}>{message}</p>
              ))
            }
          />

          <label htmlFor="content">Content</label>
          <textarea
            {...register("content", {
              required: "This field is required",
              maxLength: {
                value: 500,
                message: "This field must not exceed 500 characters long",
              },
            })}
          ></textarea>
          <ErrorMessage
            errors={errors}
            name="content"
            render={({ messages }) =>
              messages &&
              Object.entries(messages).map(([type, message]) => (
                <p key={type}>{message}</p>
              ))
            }
          />

          <Button type="submit" text="Submit" />
        </Form>
        <Divider>
          <span>OR</span>
        </Divider>
        <Social>
          <a
            href="mailto: mohamed.a.hamaida@gmail.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            <div className="socialIcon">
              <FontAwesomeIcon icon={faEnvelopeOpen} />
            </div>
            <div className="description">Email me directly</div>
          </a>

          <a
            href="https://twitter.com/Moh_Hamaida"
            target="_blank"
            rel="noopener noreferrer"
          >
            <div className="socialIcon">
              <FontAwesomeIcon icon={faTwitter} />
            </div>
            <div className="description">Follow me on Twitter</div>
          </a>

          <a
            href="https://github.com/mohamedhmda"
            target="_blank"
            rel="noopener noreferrer"
          >
            <div className="socialIcon">
              <FontAwesomeIcon icon={faGithub} />
            </div>
            <div className="description">Collaborate on Github</div>
          </a>
          <a
            href="https://www.facebook.com/profile.php?id=100014322403921"
            target="_blank"
            rel="noopener noreferrer"
          >
            <div className="socialIcon">
              <FontAwesomeIcon icon={faFacebookF} />
            </div>
            <div className="description">Add me on Facebook</div>
          </a>

          <a
            href="https://www.linkedin.com/in/mohamed-hamaida/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <div className="socialIcon">
              <FontAwesomeIcon icon={faLinkedinIn} />
            </div>
            <div className="description">Connect on LinkedIn</div>
          </a>

          <a
            href="https://www.instagram.com/mohamedhmda/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <div className="socialIcon">
              <FontAwesomeIcon icon={faInstagram} />
            </div>
            <div className="description">Follow me on Instagram</div>
          </a>
        </Social>
      </Content>
    </Wrapper>
  )
}

export default ContactForm
